import { GoExternalSite } from "components/common/Link";
import { useEventHeadMeta } from "hooks/event/useEventHeadMeta";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";
import { getRedirectDomainByHostingType } from "utility/hosting";

import type { FC, PropsWithChildren } from "react";
import type { EventInfo } from "utility";

type Props = PropsWithChildren<{
  event: Pick<
    EventInfo,
    "belongedHostings" | "description" | "eventId" | "title"
  >;
  pathname: string;
  redirectPath: string;
}>;

/**
 * `EventBase`はlocation変更時にイベント購読を終了して`displayEvent`をclearするため、
 * 配下のリセール画面間を遷移すると子がunmountし、選択枚数のstateを引き継げない。
 * リセールはイベント情報の取得方法も既存イベント画面と異なるため、
 * 申込ルートを`EventBase`の外に配置している。
 *
 * その結果、`EventBase`とリセール申込ルートに重複するhead設定、所属ドメイン判定、
 * 外部ドメインへの誘導を共通利用するため、この境界へ切り出している。
 */
export const EventRouteBoundary: FC<Props> = ({
  children,
  event,
  pathname,
  redirectPath,
}) => {
  const { t } = useI18n();

  useEventHeadMeta({ event, pathname });

  const redirectDomain = getRedirectDomainByHostingType(event.belongedHostings);

  if (redirectDomain) {
    return (
      <GoExternalSite
        externalLink={`https://${redirectDomain}${redirectPath}`}
        caution={t("common.externalSite.loginAgainCaution")}
      />
    );
  }

  return <>{children}</>;
};
